// extracted by mini-css-extract-plugin
export default {"item":"user-edit_item__WqWnj"};